import React from 'react';

const Message = ({ children }) => {
  return (
    <div role='alert' className=' max-w-md justify-center mx-auto' dir='rtl'>
      <div className='bg-red-500 text-white font-bold rounded-t px-4 py-2 '>
        خطا!
      </div>
      <div className='border border-t-0 border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700'>
        <p>{children}.</p>
      </div>
    </div>
  );
};

export default Message;
